export default function (instance) {
    return {
        getDocuments(params){
            return instance.get('documents', { params })
        },
    }
}